import * as _ from 'lodash';

export class ObjectUtil {
  /**
   * Deep version of Object.assign. In contrast to Object.assign, this method
   * does not alter the first argument, but only returns the new object.
   *
   * @param source Base object to start with
   * @param sources Additional objects to assign over the base object
   * @returns The new object
   */
  public static assign(source: any, ...sources: any[]): any {
    return _.assign({}, ...[source, ...sources].map(s => _.cloneDeep(s)));
  }



  /**
   * Checks whether an object is not undefined.
   *
   * @param object Object to check
   * @returns true when the object not undefined
   */
  public static isDefined<T>(object: T | undefined): object is T {
    return object !== undefined;
  }

  /**
   * Checks whether an object is not null.
   *
   * @param object Object to check
   * @returns true when the object is not null
   */
  public static isNotNull<T>(object: T | null): object is T {
    return object !== null;
  }

  /**
   * Maps all the values of the provided object
   *
   * @param source Base object to start with
   * @returns The new object
   */
  public static values(source: any): any {
    return Object.keys(source).map(k => source[k]);
  }

  /**
   * Checks whether an object is of type object
   *
   * @param object Object to check
   * @returns true when object is of type object
   */
  public static isObjectType(object: any): boolean {
    return Object.prototype.toString.call(object) === '[object Object]';
  }
}
